import type { Ref } from 'react';
import { useKey } from 'react-use';
import styled, { css } from 'styled-components';

import { fadeIn } from '#src/atoms/animations/keyframes.ts';
import { theme } from '#src/style/theme.tsx';

const BackdropWrapper = styled.div<{ blur: boolean; delay: number }>`
  position: fixed;
  z-index: ${theme.zIndex.backdrop};
  inset: 0;
  background: rgba(var(--c-rgb-black), 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  animation: ${fadeIn} 0.25s ${({ delay }) => delay}ms ease-in-out forwards;
  ${({ blur }) =>
    blur
      ? css`
          backdrop-filter: blur(4px);
        `
      : ''};
`;

type Props = {
  onClick?: () => void;
  blur?: boolean;
  children?: React.ReactNode;
  className?: string;
  delay?: number;
  ref?: Ref<HTMLDivElement>;
};

export const Backdrop = ({
  onClick,
  blur = false,
  children,
  className,
  delay = 0,
  ref,
}: Props) => {
  useKey('Escape', onClick);
  return (
    <BackdropWrapper
      blur={blur}
      delay={delay}
      onClick={onClick}
      as={onClick ? 'button' : 'div'}
      className={className}
      ref={ref}
    >
      {children}
    </BackdropWrapper>
  );
};
